/**
 * Validate required inputs before enabling AI generation.
 * @param {Array<{ getValue?: Function, name?: string, minLength?: number, errorMsg?: string, ErrorMsg?: string }>} rules
 * @param {object} formData
 */
export const validateAIRequiredFields = (rules, formData) => {
  const list = Array.isArray(rules) ? rules : [];

  for (const rule of list) {
    const raw =
      typeof rule.getValue === "function"
        ? rule.getValue(formData)
        : formData?.[rule.name];
    const value = String(raw ?? "").trim();
    const minLen = rule.minLength ?? rule.minlength ?? 0;

    if (!value || (minLen > 0 && value.length < minLen)) {
      return {
        valid: false,
        errorMsg:
          rule.errorMsg ||
          rule.ErrorMsg ||
          "Please complete required fields before generating.",
      };
    }
  }

  return { valid: true, errorMsg: "" };
};

/**
 * Build dynamicFields payload for POST /ai/generate from required field rules.
 */
export const buildDynamicFieldsFromRules = (rules, formData) => {
  const out = {};
  const list = Array.isArray(rules) ? rules : [];

  list.forEach((rule) => {
    const key = rule.dynamicFieldKey || rule.DynamicFieldKey;
    if (!key) return;

    const raw =
      typeof rule.getValue === "function"
        ? rule.getValue(formData)
        : formData?.[rule.name];
    out[key] = String(raw ?? "").trim();
  });

  return out;
};
